<template>
  <el-row class="container"
          v-loading.fullscreen.lock="loading"
          element-loading-text="Fetching order details..."
          element-loading-background="white">
    <section class="orders-block">
      <h1>#Orders</h1>
      <el-row type="flex" justify="center">
        <el-col :lg="24">
          <OrderCard :order="order" v-for="order in getTableOrders" :key="order.id"/>
        </el-col>
      </el-row>
      <el-row>
        <el-pagination
          v-if="orderResults.length"
          class="mb-40 text-center"
          background
          :page-size.sync="orderResults.per_page"
          :current-page.sync="orderResults.current_page"
          layout="prev, pager, next"
          :page-count="orderResults.total"
          :total="orderResults.total"
          @current-change="fetchOrders"
        ></el-pagination>
      </el-row>
    </section>
  </el-row>
</template>

<script>
import OrderCard from "./OrderCard";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ListOrders",
  components: {OrderCard},
  data() {
    return {
      loading: true,
      orderResults: {},
    };
  },
  computed: {
    ...mapGetters('orders', ['getOrders', 'getTableOrders'])
  },
  async created() {
    await this.fetchOrders();
  },
  methods: {
    ...mapActions({
      orders: 'orders/all'
    }),
    async fetchOrders(page = 1) {
      this.loading = true;
      await this.orders({
        page: page
      });
      this.orderResults = {...{}, ...this.getOrders};
      this.loading = false
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
}
</script>

<style scoped lang="scss">
@media all and (max-width: 768px) {
  .orders-block {
    padding: 0 10px;
  }
}
</style>
